module.exports = __webpack_public_path__ + "img/wolf.37a789d5.png";